import { createInteractionMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import {
	OPEN_LOOM_RECORDER_SDK_INTERACTION,
	INITIALIZE_LOOM_RECORDER_SDK_INTERACTION,
} from '@confluence/browser-metrics/entry-points/metric-keys.ts';

export const OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC = createInteractionMetric({
	key: OPEN_LOOM_RECORDER_SDK_INTERACTION,
});

export const INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC = createInteractionMetric({
	key: INITIALIZE_LOOM_RECORDER_SDK_INTERACTION,
});
